import React from 'react';
import { Box, IconButton, Link, Typography } from '@mui/material';
import { Download, Paperclip } from 'react-feather';
import { AssistantEmailAttachment } from './types';

export const EmailDraftAttachments = ({
  attachments = [],
  additions = true,
}: {
  attachments?: AssistantEmailAttachment[];
  additions?: boolean;
}) => {
  if (!attachments?.length) return null;
  return (
    <Box sx={{ my: 1.5, minWidth: 0 }}>
      <Typography variant="body2" color="text.secondary">
        {additions
          ? 'Adds these files; keeps existing attachments.'
          : 'Attached files'}
      </Typography>
      {attachments.map((attachment) => (
        <Box
          key={attachment.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            mt: 0.5,
            minWidth: 0,
          }}
        >
          <Paperclip size={14} aria-hidden="true" style={{ flexShrink: 0 }} />
          <Link
            href={attachment.available === false ? undefined : attachment.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="text.secondary"
            title={attachment.filename}
            sx={{
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: 14,
            }}
          >
            {attachment.filename}
          </Link>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ flexShrink: 0 }}
          >
            {attachment.byteSize == null
              ? 'Size unavailable'
              : `${(attachment.byteSize / 1048576).toFixed(2)} MiB`}
          </Typography>
          {attachment.available === false ? (
            <Typography variant="caption" color="error">
              Unavailable
            </Typography>
          ) : null}
          {attachment.available !== false && attachment.downloadUrl && (
            <IconButton
              component="a"
              href={attachment.downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              aria-label={`Download ${attachment.filename}`}
            >
              <Download size={14} />
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  );
};
